import { render, staticRenderFns } from "./ProbabilityCard.vue?vue&type=template&id=41dda9ae&scoped=true"
import script from "./ProbabilityCard.vue?vue&type=script&lang=js"
export * from "./ProbabilityCard.vue?vue&type=script&lang=js"
import style0 from "./ProbabilityCard.vue?vue&type=style&index=0&id=41dda9ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dda9ae",
  null
  
)

export default component.exports